import { useState, forwardRef } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { Input } from '@/components/ui/input';

/**
 * Password input with an eye-toggle to reveal what's typed. Drop-in
 * replacement for `<Input type="password" />` — accepts the same props.
 *
 * The visibility lives in this component (uncontrolled). Callers can pass
 * `defaultVisible` to start revealed (e.g. for "set new password" screens).
 */
export const PasswordInput = forwardRef(function PasswordInput(
  { defaultVisible = false, className = '', ...props },
  ref,
) {
  const [visible, setVisible] = useState(defaultVisible);
  const Icon = visible ? EyeOff : Eye;

  return (
    <div className="relative">
      <Input
        ref={ref}
        type={visible ? 'text' : 'password'}
        className={`pr-10 ${className}`}
        {...props}
      />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        tabIndex={-1}
        aria-label={visible ? 'Hide password' : 'Show password'}
        className="absolute inset-y-0 right-0 px-3 flex items-center text-gray-400 hover:text-gray-600 focus:outline-none"
        data-testid={props['data-testid'] ? `${props['data-testid']}-toggle` : undefined}
      >
        <Icon className="h-4 w-4" />
      </button>
    </div>
  );
});
